// src/components/admin/AdminReservations.jsx — toutes les réservations + montants

import React from "react";
import { useSearchParams } from "react-router-dom";
import { getReservationsAdmin } from "../../services/AdminGestionService";
import { useListeAdmin, TableAdmin, Pagination, Recherche, Filtre, EnTete, Badge, BoutonActualiser, euros, dateFr } from "./AdminUI";

const VERSEMENT = {
    en_attente: ["orange", "En attente"],
    verse: ["vert", "Versé"],
    echec: ["rouge", "Échec"],
    annule: ["gris", "Annulé"],
};

const AdminReservations = () => {
    const [params, setParams] = useSearchParams();
    const evenementId = params.get("evenement_id") || "";
    const L = useListeAdmin(getReservationsAdmin, { q: "", statut: "", type: "", evenement_id: evenementId });

    const colonnes = [
        { cle: "reference", titre: "Réf.", rendu: (r) => <span className="font-mono text-xs">{r.reference || `#${r.id}`}</span> },
        { cle: "created_at", titre: "Date", rendu: (r) => <span className="text-xs text-gray-500 whitespace-nowrap">{dateFr(r.created_at, true)}</span> },
        { cle: "nom_personne", titre: "Participant", rendu: (r) => (
            <div>
                <div className="font-semibold text-gray-900">{r.nom_personne}</div>
                <div className="text-[11px] text-gray-500">{r.acheteur_email}</div>
            </div>
        )},
        { cle: "nomEven", titre: "Événement", rendu: (r) => (
            <div className="max-w-[200px]">
                <div className="text-gray-800 line-clamp-1">{r.nomEven}</div>
                <div className="text-[11px] text-gray-500">{dateFr(r.dateEven)} · {r.createur_email}</div>
            </div>
        )},
        { cle: "nombre_personnes", titre: "Places", classe: "text-center" },
        { cle: "paye", titre: "Payé", classe: "text-right", rendu: (r) =>
            r.stripe_payment_intent_id
                ? (r.montant_paye_total != null ? euros(r.montant_paye_total) : <span className="text-gray-400 text-xs">à synchro</span>)
                : <Badge couleur="bleu">Gratuit</Badge> },
        { cle: "orga", titre: "Part orga", classe: "text-right", rendu: (r) => r.stripe_payment_intent_id ? euros(r.montant_organisateur) : "—" },
        { cle: "stripe", titre: "Frais Stripe", classe: "text-right", rendu: (r) => r.frais_stripe != null ? <span className="text-gray-500">{euros(r.frais_stripe)}</span> : "—" },
        { cle: "commission", titre: "Commission", classe: "text-right", rendu: (r) =>
            r.montant_paye_total != null
                ? <span className="text-green-700 font-semibold">{euros(r.montant_paye_total - (r.montant_organisateur || 0) - (r.frais_stripe || 0))}</span>
                : "—" },
        { cle: "statut", titre: "Statut", rendu: (r) =>
            r.statut === "annulee"
                ? <div><Badge couleur="rouge">Annulée</Badge>{r.annulee_par && <div className="text-[10px] text-gray-500 mt-0.5">par {r.annulee_par} · {euros(r.montant_rembourse)} remb.</div>}</div>
                : Number(r.valide) ? <Badge couleur="bleu">Utilisée</Badge> : <Badge couleur="vert">Valide</Badge> },
        { cle: "versement", titre: "Versement", rendu: (r) => {
            const v = VERSEMENT[r.statut_versement];
            return v ? <Badge couleur={v[0]}>{v[1]}</Badge> : <span className="text-gray-300">—</span>;
        }},
    ];

    return (
        <div className="max-w-7xl mx-auto">
            <EnTete titre="Réservations" sousTitre={`${L.page?.total ?? "…"} réservation(s)`}
                actions={<>
                    <Recherche valeur={L.filtres.q} onChange={(v) => L.setFiltre("q", v)} placeholder="Réf., nom, e-mail, événement…" />
                    <Filtre valeur={L.filtres.statut} onChange={(v) => L.setFiltre("statut", v)}
                        options={[["", "Tous statuts"], ["active", "Valides"], ["utilisee", "Utilisées"], ["annulee", "Annulées"]]} />
                    <Filtre valeur={L.filtres.type} onChange={(v) => L.setFiltre("type", v)}
                        options={[["", "Payantes + gratuites"], ["payant", "Payantes"], ["gratuit", "Gratuites"]]} />
                    <BoutonActualiser onClick={L.recharger} />
                </>}
            />
            {evenementId && (
                <div className="mb-4 flex items-center gap-2 text-xs">
                    <Badge couleur="violet">Événement #{evenementId}</Badge>
                    <button className="text-gray-500 underline" onClick={() => { setParams({}); L.setFiltre("evenement_id", ""); }}>retirer le filtre</button>
                </div>
            )}
            <TableAdmin colonnes={colonnes} lignes={L.page?.data} loading={L.loading} erreur={L.erreur} />
            <Pagination page={L.page} onPage={L.allerA} onParPage={L.setParPage} />
        </div>
    );
};

export default AdminReservations;